import { render, staticRenderFns } from "./Total.vue?vue&type=template&id=53e1fb5a&scoped=true&"
var script = {}
import style0 from "./Total.vue?vue&type=style&index=0&id=53e1fb5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e1fb5a",
  null
  
)

export default component.exports